// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__xHiwb","title":"AfterFrontImage_title__iGJAw"};